export const GreenDot = () => (
  <div className="flex-none rounded-full p-1 text-green-400 bg-green-400/10">
    <div className="h-2 w-2 rounded-full bg-current" />
  </div>
);
